import { reissueAccountBadgesBulkActionName } from '../../../../backend/features/badges/shared';
import { useBadgingTranslation } from '../../../../ui/hooks';
import { showAlertSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { launchBulkAction } from '@juvare/platform-sdk-react/ui/features/bulk-actions';
export function useAccountBadgeReissueBulkAction(options) {
    const { t } = useBadgingTranslation();
    const handleReissueAccountBadges = (badgeId, accountBadgesToReissue, onSuccess, onClose) => {
        var _a;
        launchBulkAction({
            title: t('badges.badgeDetails.accountBadgeTable.reissueDialog.progress'),
            type: reissueAccountBadgesBulkActionName,
            params: { badgeId, accountBadgesToReissue },
            runSync: (_a = options === null || options === void 0 ? void 0 : options.runSync) !== null && _a !== void 0 ? _a : false,
            onClose: (params) => {
                if (params.status === 'finished') {
                    showAlertSnackbar({
                        horizontalPosition: 'center',
                        type: 'success',
                        verticalPosition: 'bottom',
                        autoHideDuration: 2000,
                        message: t('badges.badgeDetails.accountBadgeTable.reissueDialog.successMessage'),
                    });
                    onSuccess();
                }
                else {
                    onClose === null || onClose === void 0 ? void 0 : onClose();
                }
            },
        });
    };
    return {
        handleReissueAccountBadges,
    };
}
